import { useCallback } from "react";
import { PorterQuotePayload } from "../types";
import { getPorterQuote } from "../services";

export type PorterDropOverride = {
  lat: number;
  lng: number;
  name: string;
  mobileNumber: string;
};

export const usePorterQuotes = () => {
  const fetchPorterQuote = useCallback(async (payload: PorterQuotePayload) => {
    try {
      const response = await getPorterQuote(payload);
      return response;
    } catch (error: any) {
      let errorMessage =
        error?.response?.data?.errorMsg ||
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        error?.message ||
        "Failed to fetch porter quote";

      if (error?.response?.status === 400 || error?.status === 400) {
        const coordinates = ` | Pickup lat. & long. : (${payload.pickupDetails.lat}, ${payload.pickupDetails.lng}) | Drop lat. & long. : (${payload.dropDetails.lat}, ${payload.dropDetails.lng})`;
        errorMessage += coordinates;
      }

      throw new Error(errorMessage);
    }
  }, []);

  const createPorterQuotePayload = useCallback(
    (
      supplier: any,
      customerRecord: any,
      customerName: string,
      dropOverride?: PorterDropOverride | null,
    ): PorterQuotePayload => {
      const pickupLat = supplier?.supplierAddress?.location?.latitude;
      const pickupLng = supplier?.supplierAddress?.location?.longitude;

      if (!pickupLat || !pickupLng) {
        throw new Error(
          "Supplier address coordinates are not available. Please check supplier data.",
        );
      }

      const dropLat =
        dropOverride?.lat ??
        customerRecord?.facet?.shipmentAddress?.location?.latitude;
      const dropLng =
        dropOverride?.lng ??
        customerRecord?.facet?.shipmentAddress?.location?.longitude;

      if (!dropLat || !dropLng) {
        throw new Error(
          dropOverride
            ? "Destination address coordinates are not available. Please check destination data."
            : "Customer address coordinates are not available. Please check customer data.",
        );
      }

      return {
        pickupDetails: {
          lat: pickupLat,
          lng: pickupLng,
        },
        dropDetails: {
          lat: dropLat,
          lng: dropLng,
        },
        customerDetails: {
          name: dropOverride?.name || customerName,
          mobileNumber:
            dropOverride?.mobileNumber ||
            customerRecord?.facet?.mobileNumber ||
            "918377992007",
        },
      };
    },
    [],
  );

  return {
    fetchPorterQuote,
    createPorterQuotePayload,
  };
};
